import React, {Component} from 'react';
import initialData from './initialData';
import { DragDropContext } from 'react-beautiful-dnd';
import styled from 'styled-components';
import Board from './Board';
import CreateBoard from './CreateBoard/CreateBoard';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import BackImg from './backbutton.svg';

const Container =  styled.div``;

const Label = styled.div`
  width: 345px;
    margin: 20px;
    background-color: white;
    color: #333;
    padding: 30px 0;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border-radius: 5.5px;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
    cursor: pointer;
    -webkit-transition: 200ms ease-in-out;
    transition: 200ms ease-in-out;
    font-weight: 900;
    text-shadow: 0px 0px 3px #white;
    -webkit-animation: eMLfYp 600ms linear;
    animation: eMLfYp 600ms linear;
`;

const LabelTitle = styled.h3`
text-transform: uppercase`;

const Navigation = styled.nav`
`;

const List = styled.ul`
display: flex;
list-style-type: none;
justify-content: center;
align-items: center;
flex-wrap:wrap;
`;

const Item = styled.li``;

const HomeContainer = styled.div`
margin-top: 25px;
display: flex;
justify-content: center;`;

const HomeButton = styled.button`
background-image: url(${BackImg});
background-repeat: no-repeat;
background-position: center;
width: 75px;
height: 75px;
background-color: transparent;
border: none;
text-align: center;
display: inline-block;
margin: 0 auto;
`;



class App extends Component {
  state = initialData;

  onDragStart = (start) => {
    
  }

  onDragUpdate = (update) => {

  }

  onDragEnd = result => {
    const {draggableId, source, destination} = result;

    if(destination === null) {
      return;
    }
    
    if(source.index === destination.index && source.droppableId === destination.droppableId) {
      return;
    }
    

    const prefix = draggableId.split('-')[0];
    const start = this.state[prefix].columns[source.droppableId];
    const finish =  this.state[prefix].columns[destination.droppableId];;

    if(start === finish) {
      const column = this.state[prefix].columns[source.droppableId];
      const newTaskIds = Array.from(column.taskIds);
  
      newTaskIds.splice(source.index, 1);
      newTaskIds.splice(destination.index, 0, draggableId);
  
      const newColumn = {
        ...column,
        taskIds: newTaskIds
      };
  
  
      const newState = {
        ...this.state,
        [prefix]: {
          ...this.state[prefix],
          columns: {
            ...this.state[prefix].columns,
            [newColumn.id]: newColumn
          }
        }
      }
  
  
    this.setState(newState);
    return;
    }

    if(start !== finish) {
      const startTaskIds = Array.from(start.taskIds);
      startTaskIds.splice(source.index, 1);

      const newStart = {
        ...start,
        taskIds: startTaskIds
      };

      const finishTaskIds = Array.from(finish.taskIds);
      finishTaskIds.splice(destination.index, 0, draggableId);

      const newFinish = {
        ...finish,
        taskIds: finishTaskIds
      };

      const newState = {
        ...this.state,
        [prefix]: {
          ...this.state[prefix],
          columns: {
            ...this.state[prefix].columns,
            [newStart.id]: newStart,
            [newFinish.id]: newFinish
          }
        }
      };

      this.setState(newState);
      return;
    }

    return;
  }

  onEnterKeyHandler = (e) => {
    if(e.key === 'Enter') {
      const newState = {
        ...this.state,
        [e.target.value]: {
          tasks: {},
          columns: {},
          columnOrder: [],
          lastColumnId: 0,
          lastTaskId: 0
        },
      }
      
      this.setState(newState);
      
      e.target.value = '';
    }
  }

  onCreateBoardHandler = e => {
    const input = e.target.parentNode.previousElementSibling;
    const value = input.value
    
    const newState = {
      ...this.state,
      [value]: {
        tasks: {},
        columns: {},
        columnOrder: [],
        lastColumnId: 0,
        lastTaskId: 0
      },
    }
    input.value = '';
    this.setState(newState);
    
  }

  onCreateColumnHandler = (e) => {
    if(e.key === 'Enter') {
      const boardName = e.target.parentNode.dataset.name;
      const columnName = e.target.value;


      const { lastColumnId } = this.state[boardName];
      
      

      const newColumnName = `${boardName}-column-${lastColumnId + 1}`;

      const newColumn = {
          id: newColumnName,
          title: columnName,
          taskIds: [], 
      };


      const newBoard = {
        ...this.state[boardName],
        columns: {
          ...this.state[boardName].columns,
          [newColumnName]: newColumn
        }
      };


      newBoard.columnOrder.push(newColumnName);
      newBoard.lastColumnId = newBoard.lastColumnId + 1;

      const newBoardProp = {
        [boardName]: newBoard
      };

  
      
      const newState = {
        ...this.state,
        [boardName]: newBoard
      }


      this.setState(newState); 


      e.target.value = '';
      }
    }

    onCreateTaskHandler = (e) => {
      if(e.key === 'Enter') {
        console.log('Someone wanna create a task');
        console.log(e.target.dataset);

        const columnId = e.target.dataset.columnId;
        const boardId = columnId.split('-')[0];
        

        const { [boardId]: board } = this.state;

        const taskId = `${boardId}-task-${board.lastTaskId + 1}`;
        console.log(taskId, 'is task id')

        console.log(board.columns)
        const newTaskIds = board.columns[columnId].taskIds.push(taskId);

        const newState = {
          ...board,
          tasks: {
            ...board.tasks,
            [taskId]: {
              id: taskId,
              content: e.target.value,
            }
          },
          columns: {
            ...board.columns,
            [boardId]: {
              ...board.columns[boardId],
              taskIds: newTaskIds
            }
          }
        };

        newState.lastTaskId = newState.lastTaskId + 1;

        this.setState({
          ...this.state,
          [boardId]: newState
        })


        e.target.value = '';
      }
    }

    on


  render() {
    const nav =  Object.keys(this.state).map(label => {
      const href=`/${label}`
      return (
        <Item>
          <Link to={href} style={{ textDecoration: 'none' }}>
            <Label> <LabelTitle> { label } </LabelTitle></Label>
          </Link>
        </Item>
      )
    })


    const boards = Object.keys(this.state).map(board => {
    const href=`/${board}`;

      return (
        <Route path={href}>
          <HomeContainer>
            <Link to="/" style={{ textDecoration: 'none' }}> <HomeButton> </HomeButton></Link>
          </HomeContainer>


          <Board
          createTask={this.onCreateTaskHandler}
          create={this.onCreateColumnHandler}
          dragStart={this.onDragStart} 
          dragEnd={this.onDragEnd} 
          data={this.state[board]} 
          name={board}/>
        </Route>
      )
  })

    return (
      <Router>
        <Container>
        

        <Switch>
          {boards} 
          <Route path='/'>
          
          <Navigation>
            <List>

            <CreateBoard  click={this.onCreateBoardHandler} enterKeyDown={this.onEnterKeyHandler}/>
              {nav}
    
            </List>
          </Navigation>
          </Route>
        </Switch>
        </Container>
      </Router>
    )
  }
}



export default App;
